import Const from 'const';
import {combineReducers} from 'redux';
import StateInterface from 'components/molecules/combo-exposure-max/interfaces/state-interface';
import ComboInterface from 'components/molecules/combo-exposure-max/interfaces/combo-interface';
import {KeyPlayerStackGroups} from 'services/key-player-stacking/key-player-stack-groups-builder';

const initialState = {
    data: {},
    ...StateInterface,
};

function exposureMax(state = {...initialState}, action) {
    switch (action.type) {
        case Const.KEY_PLAYER_STACKING_COMBO_SET_EXPOSURE_MAX:
            const {params} = action;
            const data = cp(state.data);
            const usi = state.doUniqueStackId(params.stackId);
            if (!data.hasOwnProperty(usi)) {
                data[usi] = {};
            }
            const comboId = state.doComboId(params.combo);
            data[usi][comboId] = {
                id: comboId,
                combo: [...params.combo],
                expMax: params.value,
                ...ComboInterface,
            };
            return {...state, data};

        case Const.RESET_ALL_SETTINGS:
        case Const.FILTER_BY_SLATE:
            return {...initialState};
        default:
            return state;
    }
}

class CombinationGroups {
    constructor(private readonly groups: KeyPlayerStackGroups = {usedInLineups: [], unusedInLineups: []}) {}
    getGroupsUsedInLineups(): any[] {
        return this.groups.usedInLineups;
    }
    getGroupsUnusedInLineups(): any[] {
        return this.groups.unusedInLineups;
    }
    hasAnyGroups() {
        return !isEmpty(this.groups.usedInLineups) || !isEmpty(this.groups.unusedInLineups);
    }
}

const combinationGroups = new CombinationGroups();

function groups(state = combinationGroups, action) {
    switch (action.type) {
        case Const.KEY_PLAYER_STACKING_SET_COMBINATION_GROUPS:
            return new CombinationGroups(action.data);
        case Const.RESET_ALL_SETTINGS:
        case Const.FILTER_BY_SLATE:
            return new CombinationGroups();
        default:
            return state;
    }
}

const reducers = {
    exposureMax,
    groups,
};

export default combineReducers(reducers);
